module.exports = __webpack_public_path__ + "static/reminder-679af3bc436013f0763dd9335378b803.mp4";